{
  "action": {
    "downloadTeamsApp": "Download Teams app (.zip)",
    "accept": "Accept",
    "acceptRedundancy": "Confirm redundant",
    "activate": "Activate",
    "add": "Add",
    "addExistingDocument": "Add existing document",
    "addField": "Add field",
    "addFieldMapping": "Add mapping",
    "addHint": "Press enter to add",
    "addIntegration": "Add integration",
    "addMember": "Add member",
    "addNestedField": "Nested field",
    "addToCalendar": "Add to calendar",
    "allDocuments": "All documents",
    "analyzeChat": "Analyze conversation",
    "apply": "Apply",
    "attachFile": "Attach a file",
    "back": "Back",
    "backToAgent": "Back to agent",
    "backToDocuments": "Back to documents",
    "backToHome": "Back to Home",
    "backToSignIn": "Back to sign in",
    "ban": "Ban user",
    "blockChat": "Block conversation",
    "cancel": "Cancel",
    "cancelInvitation": "Cancel invitation",
    "change": "Change",
    "changeAgent": "Change agent",
    "changeRole": "Change role",
    "check": "Check",
    "clear": "Clear",
    "close": "Close",
    "closeSidebar": "Close sidebar",
    "compare": "Compare",
    "collapse": "Collapse",
    "connect": "Connect",
    "continue": "Continue",
    "copied": "Copied",
    "copy": "Copy",
    "crawl": "Crawl",
    "create": "Create",
    "createAgent": "Create agent",
    "createApiKey": "Create API Key",
    "createDocument": "Create document",
    "createFolder": "Create folder",
    "createNew": "Create new",
    "createNewChat": "Start a new chat",
    "createNotification": "Create notification",
    "createRevise": "Revise answer",
    "createSubfolder": "Create subfolder",
    "deactivate": "Deactivate",
    "decline": "Decline",
    "delete": "Delete",
    "deleteAllNotifications": "Delete all notifications",
    "deleteFolder": "Delete folder",
    "deleteMyConversations": "Delete my conversations",
    "deleteProfile": "Delete profile",
    "deleteRow": "Delete row",
    "deselectHint": "Press enter to remove",
    "disableAutoRefresh": "Disable automatic update",
    "dismissRedundancy": "Restore to search",
    "disconnect": "Disconnect",
    "download": "Download",
    "downloadIcs": "Download .ics",
    "downvote": "I don't like",
    "dropFile": "Drop file here",
    "dropFilesToImport": "Drop files to import the documents",
    "duplicate": "Duplicate",
    "edit": "Edit",
    "editAgent": "Edit agent",
    "editDocument": "Edit document",
    "editRevise": "Update revised answer",
    "editSchema": "Edit schema",
    "enableAutoRefresh": "Enable automatic update",
    "expand": "Expand",
    "export": "Export",
    "exportMyData": "Export my data",
    "feedback": "I want to make a report",
    "foldSidebar": "Close sidebar",
    "forgetPassword": "Do you forget the password?",
    "generate": "Generate",
    "generateFromJson": "Generate from JSON",
    "getDirections": "Directions",
    "getMoreInfo": "More informations",
    "goBack": "Go back",
    "impersonate": "Impersonate",
    "import": "Import ({count})",
    "importFromCrawler": "Import from Crawler",
    "invite": "Invite",
    "inviteMember": "Invite member",
    "leave": "Leave",
    "link": "Link",
    "linkExisting": "Link existing",
    "loadDefaults": "Load defaults",
    "manageAgentAccess": "Manage agent access",
    "manageProfile": "Manage your profile",
    "markAllAsRead": "Mark all as read",
    "markAsRead": "Mark as read",
    "moreActions": "Actions",
    "moveDown": "Move down",
    "moveHere": "Move here",
    "moveToFolder": "Move to folder",
    "moveUp": "Move up",
    "next": "Next",
    "open": "Open",
    "openFilters": "Open the filters",
    "openInGmail": "Open in Gmail",
    "openInMailApp": "Open in mail app",
    "openInOutlook": "Open in Outlook",
    "openInSms": "Open in SMS",
    "openInTelegram": "Open in Telegram",
    "openInWhatsApp": "Open in WhatsApp",
    "openInYahooMail": "Open in Yahoo Mail",
    "openSidebar": "Open sidebar",
    "pan": "Pan",
    "pin": "Pin",
    "prev": "Previous",
    "previewAsPage": "Preview as chat page",
    "previewAsWidget": "Preview as widget",
    "previous": "Previous",
    "proceed": "Proceed",
    "recoverPassword": "Recover password",
    "refill": "Refill",
    "refillHistory": "Refill history",
    "refresh": "Refresh",
    "regenerate": "Regenerate",
    "remove": "Remove",
    "removeField": "Remove field",
    "renameChat": "Rename",
    "renameFolder": "Rename folder",
    "reorder": "Reorder",
    "reprocess": "Reprocess",
    "resendInvitation": "Resend invitation",
    "reset": "Reset",
    "resetPassword": "Reset password",
    "resize": "Resize",
    "retry": "Retry",
    "retryNow": "Try again now",
    "revoke": "Revoke",
    "revokeAllOtherSessions": "Sign out all",
    "rootDocuments": "Without folder",
    "run": "Run",
    "save": "Save",
    "scrollToBottom": "Back to bottom",
    "searchAllFolders": "Search in all folders",
    "select": "Select",
    "selectHint": "Press enter to select",
    "selected": "Selected",
    "send": "Send",
    "share": "Share",
    "shareDocumentWithAgents": "Share with other agents",
    "showLess": "Show less",
    "showMore": "View more {count}",
    "signIn": "Sign in",
    "signInWithSocialProvider": "Sign in with {provider}",
    "signOut": "Sign out",
    "signUp": "Sign up",
    "signUpWithSocialProvider": "Sign up with {provider}",
    "startNewChat": "Start a new chat",
    "stop": "Stop",
    "stopImpersonation": "Stop impersonation",
    "submit": "Submit",
    "switch": "Switch",
    "takePhoto": "Take a photo",
    "testIntegration": "Test connection",
    "toggleIntegration": "Enable/Disable",
    "toggleTheme": "Change theme",
    "unban": "Unban user",
    "unblockChat": "Unblock conversation",
    "unfoldSidebar": "Open sidebar",
    "unlinkDocument": "Unlink from agent",
    "unpin": "Unpin",
    "update": "Update",
    "upvote": "I like!",
    "useColorsForAgentHeader": "Use color for header",
    "view": "View",
    "viewAgentTree": "View tree",
    "viewAll": "View all",
    "viewChat": "View the chat",
    "viewDetails": "View details",
    "viewProfile": "View profile",
    "viewRecentChats": "View recent chats",
    "welcomePopup": "Show welcome popup",
    "zoomIn": "Zoom In",
    "zoomOut": "Zoom Out"
  },
  "agent": {
    "channel": {
      "app": "App",
      "frontoffice": "Frontoffice",
      "widget": "Widget"
    },
    "reasoning": {
      "high": "High",
      "low": "Low",
      "medium": "Medium",
      "off": "Off"
    },
    "reasoningSummary": {
      "auto": "Auto",
      "concise": "Concise",
      "detailed": "Detailed"
    },
    "searchMode": {
      "balanced": "Balanced (vector + keywords)",
      "keyword": "Keyword (full-text only)",
      "semantic": "Semantic (vector only)"
    },
    "status": {
      "active": "Active",
      "draft": "Draft",
      "inactive": "Inactive"
    },
    "tool": {
      "geocode": "Geocoding",
      "getWeather": "Weather data",
      "readDocumentFile": "Read document files",
      "requestGeolocation": "Geolocation",
      "retrieveRevisedAnswers": "Verified answers",
      "searchInKnowledgeBase": "Knowledge base",
      "searchInUserFiles": "User files",
      "userMemory": "User memory",
      "runWorker": "Parallel workers",
      "useAllUserKb": "Use the entire user KB",
      "useAllUserFiles": "Use all user files",
      "showArtifact": "Artifacts",
      "showCalendarEvent": "Calendar event",
      "showComparison": "Comparison",
      "showContactForm": "Contact form",
      "showDiagram": "Diagram or chart",
      "showEmail": "Email",
      "showForm": "Multi-step Form",
      "showImageGallery": "Image gallery",
      "showLocation": "Interactive map",
      "showMessage": "Messaging",
      "showMultipleChoice": "Multiple choice",
      "showProductList": "Product catalog",
      "showQrCode": "QR code",
      "showSources": "Sources & references",
      "showSuggestedReply": "Suggested replies",
      "showWeather": "Weather widget",
      "showWebPages": "Web page links"
    },
    "visibility": {
      "organization": "Organization",
      "private": "Private",
      "public": "Public"
    }
  },
  "agentApiToolStatus": {
    "active": "Active",
    "inactive": "Inactive"
  },
  "agentType": {
    "chat": "Chat",
    "reasoning": "Reasoning"
  },
  "auth": {
    "emailInUse": "An account with this email already exists",
    "emailNotVerified": "Please verify your email address",
    "genericError": "An error occurred. Please try again.",
    "haveAccount": "Already have an account?",
    "invalidCredentials": "Invalid email or password",
    "noAccount": "Don't have an account?",
    "popupBlocked": "Pop-up blocked. Please allow pop-ups for this site and try again.",
    "resetSent": "If an account exists with this email, you will receive a password reset link.",
    "resetSentTitle": "Check your email",
    "resetTitle": "Reset your password",
    "signInTitle": "Sign in to your account",
    "signUpSuccessTitle": "Account created!",
    "signUpTitle": "Create your account",
    "verifyEmail": "We've sent a verification email to your address. Please check your inbox."
  },
  "browserEngine": {
    "fetch": "Fetch · static HTML",
    "puppeteer": "Puppeteer · local browser",
    "remote": "Remote · remote browser"
  },
  "chartLabel": {
    "2g": "2G",
    "3g": "3G",
    "4g": "4G",
    "Africa": "Africa",
    "America": "America",
    "Asia": "Asia",
    "Australia": "Australia",
    "Europe": "Europe",
    "Pacific": "Pacific",
    "abusive": "Abusive",
    "aggressive": "Aggressive",
    "critical": "Critical",
    "dark": "Dark",
    "data_leak": "Data leak",
    "degrading": "Degrading",
    "desktop": "Desktop",
    "direct": "Direct",
    "disengaged": "Disengaged",
    "excited": "Excited",
    "frustrated": "Frustrated",
    "goal_met": "Goal met",
    "goal_not_met": "Goal not met",
    "hallucination": "Hallucination",
    "high": "High",
    "impatient": "Impatient",
    "improving": "Improving",
    "inappropriate_tone": "Inappropriate tone",
    "light": "Light",
    "low": "Low",
    "medium": "Medium",
    "mobile": "Mobile",
    "negative": "Negative",
    "neutral": "Neutral",
    "off_brand": "Off-brand",
    "other": "Other",
    "polite": "Polite",
    "positive": "Positive",
    "refusal_loop": "Refusal loop",
    "repetition": "Repetition",
    "slow-2g": "Slow 2G",
    "stable": "Stable",
    "tablet": "Tablet",
    "unanalyzed": "Unanalyzed",
    "unclear": "Unclear",
    "unknown": "Unknown"
  },
  "conversationAnalysis": {
    "abuseCategory": {
      "data_extraction": "Data extraction",
      "harassment": "Harassment",
      "hate_speech": "Hate speech",
      "impersonation": "Impersonation",
      "off_topic_persistent": "Off-topic",
      "prompt_injection": "Prompt injection",
      "self_harm": "Self harm",
      "sexual_content": "Sexual content",
      "spam": "Spam",
      "violence": "Violence"
    },
    "confidence": {
      "high": "High",
      "low": "Low",
      "medium": "Medium"
    },
    "engagement": {
      "disengaged": "Disengaged",
      "high": "High",
      "low": "Low",
      "medium": "Medium"
    },
    "label": {
      "abuseDetected": "Abuse",
      "conversationSentiment": "Sentiment",
      "goalMet": "Goal met",
      "goalNotMet": "Goal not met",
      "llmIssueDetected": "LLM issue",
      "riskScore": "Risk score",
      "userEngagement": "Engagement",
      "userTone": "Tone"
    },
    "llmIssue": {
      "data_leak": "Data leak",
      "hallucination": "Hallucination",
      "inappropriate_tone": "Inappropriate tone",
      "off_brand": "Off-brand",
      "refusal_loop": "Refusal loop",
      "repetition": "Repetition"
    },
    "sentiment": {
      "excited": "Excited",
      "frustrated": "Frustrated",
      "negative": "Negative",
      "neutral": "Neutral",
      "positive": "Positive"
    },
    "sentimentTrend": {
      "degrading": "Degrading",
      "improving": "Improving",
      "stable": "Stable"
    },
    "title": "Conversation analysis",
    "tone": {
      "abusive": "Abusive",
      "aggressive": "Aggressive",
      "impatient": "Impatient",
      "neutral": "Neutral",
      "polite": "Polite"
    },
    "trigger": {
      "agent_request": "On request",
      "manual": "Manual",
      "summary_cycle": "Automatic"
    }
  },
  "crawlMode": {
    "depth": "Depth Crawling",
    "sitemap": "XML Sitemap"
  },
  "diagram": {
    "classDiagram": "Class Diagram",
    "erDiagram": "ER Diagram",
    "flowchart": "Flowchart",
    "graph": "Graph",
    "sequenceDiagram": "Sequence Diagram",
    "stateDiagram": "State Diagram",
    "xychart": "XY Chart"
  },
  "documentMetadata": {
    "analyzedPages": "analyze {pages} on",
    "pageCount": "no pages | {n} page | {n} pages",
    "readingTime": "{minutes} min",
    "wordCount": "{count} words",
    "redundantChunks": "no redundant chunks | {n} redundant chunk ({percent}%) | {n} redundant chunks ({percent}%)",
    "isRedundant": "Redundant",
    "redundancyAccepted": "Confirmed",
    "redundancyDismissed": "Restored",
    "availableForSearch": "Available for the agent's search",
    "notAvailableForSearch": "Not available for the agent's search",
    "searchSynced": "Available",
    "searchNotSynced": "Preparing",
    "hasRedundant": "This document contains redundant information with other files",
    "redundantWith": "Redundant with chunk {chunkId} of {docName} ({score}% semantic similarity)",
    "viewOriginal": "View original",
    "viewByChunks": "View by chunks",
    "viewDocument": "Document",
    "compare": "Compare",
    "compareChunks": "Semantic Chunk Comparison",
    "originalChunk": "Original Chunk (Authoritative)",
    "redundantChunk": "Redundant Chunk (Duplicate)",
    "thisDocument": "This document",
    "chunkSimilarTo": "{score}% similar to content in “{docName}”",
    "redundancyExplainer": "These text blocks are very similar to content already present in other documents. Confirm redundancy to exclude them from search, or restore them to keep them active.",
    "redundantWarningTitle": "Duplicate or redundant content detected inside Knowledge Base",
    "redundantWarningMessage": "Some documents contain duplicate or redundant semantic chunks. They are automatically skipped during query retrieval to clean and optimize RAG context windows.",
    "redundantWarningServerMessage": "There are {chunks} unmanaged redundant semantic chunks distributed across {docs} documents for this agent (out of {totalChunks} chunks and {totalDocs} documents).",
    "filterRedundant": "Show redundant",
    "filterOnlyRedundantLabel": "Show only documents with unmanaged redundant chunks",
    "redundantChunksStat": "Redundant chunks",
    "affectedDocumentsStat": "Affected documents",
    "showAll": "Show all"
  },
  "documentStatus": {
    "failed": "Failed",
    "pending": "Pending",
    "processing": "Processing",
    "success": "Success"
  },
  "documentType": {
    "file": "File",
    "plain-text": "Plain text",
    "revised-answer": "Revised answer",
    "url": "Web page"
  },
  "errors": {
    "RATE_LIMIT_EXCEEDED": "Rate limit exceeded",
    "fileAlreadyImported": "This file has already been imported as a document",
    "invalidToken": "Request no longer valid",
    "passwordsDoNotMatch": "Passwords do not coincide",
    "required": "Required",
    "slugAlreadyExists": "The slug already exists",
    "slugFormat": "The slug can only contain lowercase letters, numbers, and hyphens (-)",
    "urlAlreadyImported": "This URL has already been imported as a document"
  },
  "externalProvider": {
    "domain": "Email domain",
    "github": "GitHub",
    "google": "Google",
    "microsoft": "Microsoft Entra"
  },
  "help": {
    "aiDescription": "An AI model analyzes the file and generates a structural description of the content. Useful for documents with tables, charts, or complex layouts.",
    "aiDescriptionModel": "The AI model used to generate the description.",
    "aiDescriptionPrompt": "Prompt used to generate the description",
    "browserEngine": "How the page is loaded before extraction",
    "fetchBrowserEngine": "fast, fetches the static HTML. Best for most sites.",
    "puppeteerBrowserEngine": "runs JavaScript with a local browser. For dynamic or single-page apps.",
    "remoteBrowserEngine": "like Puppeteer, but on a remote browser. Bypasses blocks and bot detection.",
    "documentFile": "PDF, Word (.docx), text files (.txt, .md, .csv) and images (.png, .jpg, .webp, .gif) are allowed",
    "followExternal": "Retrieve links from different domains",
    "forceOcr": "Force text extraction via OCR (Document Intelligence). Useful for scanned PDFs or when the normal extraction produces insufficient results.",
    "pages": "Specify which pages to process. Leave empty to process all pages. Extraction will use OCR (Document Intelligence).",
    "useBrowserEngine": "Slower, but allows analysis of dynamic pages",
    "useExtractionStrategy": "Improve data extraction with AI"
  },
  "hint": {
    "platformSupported": "Renders natively on WhatsApp and Teams",
    "webhookUrl": "Paste this URL into the platform's webhook / messaging endpoint configuration.",
    "teamsAccentColor": "Defaults to the agent's theme color.",
    "whatsappVerifyToken": "Paste this token into the Meta webhook configuration.",
    "userFeedbackPositive": "The user rated this answer positively",
    "userFeedbackNegative": "The user rated this answer negatively",
    "userFeedbackComment": "The user left a comment on this answer",
    "userFeedbackReaction": "The user reacted to this answer",
    "freshnessScaleTooltip": "The half-life of the exponential decay. A document as old as this value will receive 50% of the maximum boost. Lower values cause older documents to lose the boost more quickly.",
    "freshnessWeightTooltip": "Maximum score bonus added to newly updated documents. A weight of 0.1 means a brand new document gets a +0.10 score advantage. This bonus decays exponentially over time until it reaches zero.",
    "mmrDiversityTooltip": "Controls how diverse the search results should be. A value near 0 focuses solely on relevance (even if results are similar). A value near 1 forces the inclusion of results with different details and themes, reducing redundancy.",
    "mmrCandidatesLimitTooltip": "The number of top candidate chunks retrieved from the database before applying the MMR diversity filter. For example, if set to 100, the system selects the 100 highest-scoring chunks first, then filters them to find the most diverse subset.",
    "allowedDomains": "Only search within these domains.",
    "audience": "The expected JWT token audience (aud). If empty, the audience is not verified.",
    "blockedDomains": "Exclude these domains from results.",
    "channel": {
      "app": "The agent is accessible via the dedicated public page.",
      "frontoffice": "The agent is visible in the Frontoffice panel.",
      "widget": "The agent can be embedded in websites via embed script."
    },
    "channelAppDisabled": "The App channel is disabled: the direct link and iframe will not work.",
    "channelWidgetDisabled": "The Widget channel is disabled: the embed code and loader will not work.",
    "customCss": "CSS injected into the widget shadow DOM. Allows styling the chat interface from the outside.",
    "disallowPromptTraining": "Route requests only to providers that do not use your data to train AI models.",
    "dismissableNotice": "It will be hidden after the first message.",
    "emailClaim": "The JWT claim containing the user email (default: email).",
    "embedCode": "Copy and paste this code to embed the agent in your website.",
    "embedIframe": "Embed the chat interface directly using an iframe. ",
    "embedPreview": "The agent will be accessible at the following URL.",
    "externalContextSchema": "Define which contextual data the hosting site can send to the agent.",
    "externalContextSchemaToggle": "Enable receiving contextual data from the hosting site.",
    "fallbackModels": "Alternative models tried in order if the primary model is unavailable.",
    "fieldMappingFallback": "Value used if the source field is empty or missing.",
    "fieldMappingSource": "Supports nested paths (e.g. metadata.urgency).",
    "fieldMappingTransformExtractDomainCompany": "Extracts the company name from the email domain (e.g. mario@acme.com → Acme). Skips free providers (gmail, outlook, etc.).",
    "fieldMappingTransformJoinArray": "Joins array values into a comma-separated string.",
    "fieldMappingTransformMapValues": "Replaces the value using the value map lookup table.",
    "fieldMappingTransformNone": "Copies the value as-is.",
    "fieldMappingTransformSplitFirstLast": "Splits text on spaces.",
    "fileUploadDisabledHint": "File upload is not enabled for this agent. You can enable it in the agent settings.",
    "fileUploadEnabled": "Allow users to attach files to their messages.",
    "formMaxOptionsPerStep": "Maximum number of options for each choice step (min. 2, max. 10).",
    "formMaxSteps": "Maximum number of steps the agent can generate in a single form (min. 1, max. 10).",
    "includeThoughts": "Streams the model's thoughts to the client along with the response.",
    "inputSchema": "JSON Schema (draft-07) of the input parameters the LLM can provide.",
    "issuer": "The issuer URL of the JWT token (iss).",
    "jwksUrl": "The JWKS endpoint URL for JWT signature verification.",
    "loadDelay": "Milliseconds to wait before injecting the widget. Useful on pages with slow AMD loaders (e.g. RequireJS).",
    "loaderStrategy": {
      "dynamic-import": "Uses import() inside a classic <script>. Fallback for pages where module scripts are blocked or intercepted by legacy loaders.",
      "inline-module": "Injects an inline <script type=\"module\"> with a static import. Bypasses RequireJS and other AMD loaders. Recommended for most sites.",
      "script-src": "Loads the bundle via <script type=\"module\" src=\"...\">. Use this on sites with strict Content Security Policy (CSP) that block inline scripts."
    },
    "mcpServerHealthCheckPath": "The endpoint used to check the health of the MCP Server (e.g., /api/health).",
    "mcpStatelessServer": "Force the client to connect in stateless mode.",
    "multipleChoiceAllowCustomAnswer": "Show a free-text field below the options so the user can type a custom answer.",
    "multipleChoiceMaxOptions": "Maximum number of options the AI can generate (min. 2, max. 10).",
    "nameClaim": "The JWT claim containing the user name (default: name).",
    "oauthCallbackUrl": "Set this URL as the Callback URL (Redirect URI) in the OAuth provider.",
    "outputSchema": "JSON Schema (draft-07) of the expected response. Informational only.",
    "passphrase": "Enter {passphrase} to confirm the operation",
    "privacyPolicyNotice": "Displayed at the bottom of the contact form. Supports Markdown.",
    "providerOrganizationId": "For Microsoft this refers to the tenant identifier (tenant ID). \nFor others, enter the email domain (e.g. company.com).",
    "providerTimeoutMs": "Timeout in milliseconds before falling back to the next provider (min 1000, max 789000). BYOK credentials only.",
    "reasoningNotSupported": "Reasoning is not supported for the selected provider.",
    "showExtendedSteps": "Shows reasoning and tool calls as an expandable timeline in the chat.",
    "smoothStream": "Smooths text streaming creating a more natural reading experience.",
    "subAgentName": "Only letters, numbers, underscores (_) and hyphens (-) are allowed.",
    "tool": {
      "geocode": "Converts place names to geographic coordinates and vice versa.",
      "getWeather": "Fetches current weather data and forecasts for a specific location.",
      "readDocumentFile": "Allows the agent to read the original file of PDF/DOCX documents from the knowledge base. Useful for tables, charts, and visual content.",
      "requestGeolocation": "Requests the user's GPS location via the browser.",
      "retrieveRevisedAnswers": "Retrieves administrator-verified answers and uses them as the primary source of truth.",
      "searchInKnowledgeBase": "Searches uploaded documents in the knowledge base to provide contextual answers.",
      "searchInUserFiles": "Searches the files this user personally uploaded in chat (their private files), kept separate from the agent knowledge base.",
      "userMemory": "Lets the agent remember and recall facts the user shares across conversations (name, preferences, etc.).",
      "runWorker": "Lets the agent run generic workers that inherit its tools to handle independent sub-tasks in parallel.",
      "useAllUserKb": "Reads the memories the user shared with all their agents, not just this one. Writing stays scoped to this agent.",
      "useAllUserFiles": "Searches all the user's files, including those uploaded on other agents, not just this agent's.",
      "showArtifact": "Displays structured content such as formatted text, code, or documents.",
      "showCalendarEvent": "Shows a calendar event with options for Google Calendar, Outlook, and .ics download.",
      "showComparison": "Compares 2 to 4 items side by side to help the user decide.",
      "showContactForm": "Displays a contact form to collect user information.",
      "showDiagram": "Renders a chart or a diagram (flowchart, sequence, class, ER, state).",
      "showEmail": "Composes a ready-to-send email from the user's email client.",
      "showForm": "Allows collecting structured input (text, numbers, dates, choices) via multi-step forms.",
      "showImageGallery": "Collects images in a browsable gallery with zoom and lightbox.",
      "showLocation": "Displays an interactive map with a marker and directions.",
      "showMessage": "Composes a message to send via WhatsApp, Telegram, or SMS.",
      "showMultipleChoice": "Presents selectable options to guide the conversation flow.",
      "showProductList": "Shows a product list with images, descriptions, and purchase links.",
      "showQrCode": "Generates a QR code from text, URLs, or structured data.",
      "showSources": "Shows references to the knowledge base documents used in the response.",
      "showSuggestedReply": "Suggests clickable replies to continue the conversation.",
      "showWeather": "Displays a weather forecast widget directly in the chat.",
      "showWebPages": "Suggests links to web pages relevant to the user's question."
    },
    "useColorsForAgentHeader": "Color the agent header based on the main color.",
    "webSearchEnabled": "Allow the agent to search the web during conversations.",
    "webSearchNative": "Uses {provider}'s built-in web search capabilities.",
    "welcomePopup": "Show a welcome popup with the initial message before the chat is opened.",
    "zeroDataRetention": "Route requests only to ZDR-compliant providers. Restricts the pool of available providers.",
    "freshnessBoost": "Applies a boost based on how recently the document was updated.",
    "freshnessScale": "Freshness Scale (Days)",
    "freshnessScaleExplanationMonths": "A document updated today gets a +{weight} bonus. This bonus halves to +{halfWeight} after {half} days and practically drops to zero (+{zeroWeight}) after {zero} days (approx. {months} months).",
    "freshnessScaleExplanationDays": "A document updated today gets a +{weight} bonus. This bonus halves to +{halfWeight} after {half} days and practically drops to zero (+{zeroWeight}) after {zero} days.",
    "freshnessWeight": "Weight multiplier of the freshness boost in the formula.",
    "mmr": "Balances semantic relevance and document diversity in search results to avoid redundant content.",
    "mmrDiversity": "Tradeoff between relevance (0.0) and diversity (1.0).",
    "mmrCandidatesLimit": "Maximum number of candidate chunks pre-selected before applying MMR."
  },
  "integrationProvider": {
    "hubspot": "HubSpot",
    "salesforce": "Salesforce"
  },
  "channelDescription": {
    "whatsapp": "Let users chat with this agent on WhatsApp via the Meta Cloud API.",
    "teams": "Publish this agent as a bot inside Microsoft Teams."
  },
  "channelGuide": {
    "title": "Setup guide",
    "intro": "Follow the steps in order. Open each linked service in a new browser tab and copy the values into the form on the left. Don't close this window until you've finished.",
    "docs": "Open the official documentation",
    "whatsapp": {
      "step1": "Open the Meta for Developers portal and sign in with your Facebook account (create one if you don't have it yet).",
      "step2": "Create a new app: choose the «Business» type, give it a name, then add the «WhatsApp» product to it.",
      "step3": "Open WhatsApp → «API Setup». Copy the «Phone number ID» (a long number, not the phone number itself) and paste it into the Phone number ID field.",
      "step4": "Still in «API Setup», generate an access token. For a connection that doesn't expire, create a «System User» token with the whatsapp_business_messaging permission, then paste it into the Access token field.",
      "step5": "Open App settings → «Basic», click «Show» next to «App secret», copy it and paste it into the App secret field. This lets us verify that incoming messages really come from Meta.",
      "step6": "We've already filled the «Verify token» field with a ready-to-use value (use «Regenerate» for a new one). You'll paste this exact value into Meta in the next step.",
      "step7": "Go back to WhatsApp → «Configuration» and edit the webhook: paste the Webhook URL shown above and the same Verify token, save, then subscribe to the «messages» event.",
      "step8": "Save the form on the left. Send a message to your WhatsApp number to check that the agent replies."
    },
    "teams": {
      "step1": "Sign in to the Microsoft Azure portal with your work or school account.",
      "step2": "Create a new «Azure Bot» resource and give it a name. When asked, choose whether it's Single or Multi-tenant — remember your choice for step 5.",
      "step3": "Open the bot you just created → «Configuration», copy the «Microsoft App ID» and paste it into the App ID field.",
      "step4": "Next to the Microsoft App ID, click «Manage password»: this opens the app's registration in Microsoft Entra ID (a different page from the bot). There, under «Certificates & secrets», create a new client secret and copy its «Value» (not the Secret ID) into the App password field. Copy it right away — it's shown only once.",
      "step5": "Set the App type to match what you chose in step 2. For Single tenant, copy the «Directory (tenant) ID» from the app registration «Overview» page into the Tenant ID field.",
      "step6": "Back in the bot → «Configuration», set the «Messaging endpoint» to the Webhook URL shown above and save.",
      "step7": "Open the bot → «Channels» and add the «Microsoft Teams» channel.",
      "step8": "Save the form on the left, then use the card menu (⋯ → Download Teams app) to get the package and upload it in Teams from «Apps → Manage your apps → Upload an app»."
    }
  },
  "integrationProviderDescription": {
    "hubspot": "Sync contacts and leads with HubSpot CRM.",
    "salesforce": "Sync contacts and leads with Salesforce CRM."
  },
  "integrationSyncStatus": {
    "failed": "Failed",
    "pending": "Pending",
    "success": "Success"
  },
  "interval": {
    "D": "day | days",
    "M": "month | months",
    "W": "week | weeks",
    "Y": "year | years"
  },
  "invitationStatus": {
    "accepted": "Accepted",
    "canceled": "Canceled",
    "expired": "Expired",
    "pending": "Pending"
  },
  "gdprRetention": {
    "legend": "Data retention (GDPR)",
    "chatLabel": "Chat anonymization",
    "anonymousLabel": "Anonymous user erasure",
    "unitDays": "days",
    "defaultDays": "Default: {count} day. | Default: {count} days.",
    "defaultDisabled": "Default: disabled."
  },
  "label": {
    "onChannels": "WA · Teams",
    "whatsapp": "WhatsApp",
    "teams": "Microsoft Teams",
    "botName": "Bot name",
    "teamsAppId": "App ID (Microsoft)",
    "teamsAppPassword": "App password / client secret",
    "teamsAppType": "App type",
    "teamsAppTenantId": "Tenant ID",
    "teamsManifestDetails": "App details (shown in Teams)",
    "teamsDeveloperName": "Developer name",
    "teamsDescriptionShort": "Short description",
    "teamsDescriptionFull": "Full description",
    "teamsAccentColor": "Accent color",
    "whatsappPhoneNumberId": "Phone number ID",
    "whatsappAccessToken": "Access token",
    "whatsappAppSecret": "App secret",
    "whatsappVerifyToken": "Verify token",
    "webhookUrl": "Webhook URL",
    "AI": "AI",
    "acceptInvitationAndCreateAccount": "Accept the invitation and create your account",
    "accountingCredit": "Accounting balance",
    "active": "Active",
    "activeSessions": "Active sessions",
    "latest": "Latest",
    "inTest": "In testing",
    "actualCost": "Actual cost",
    "addApiTool": "Add API Tool",
    "addIntegration": "Add integration",
    "additionalMetadata": "Additional metadata",
    "admin": "Admin",
    "advancedOptions": "Advanced options",
    "agent": "Agent",
    "agentResponse": "Agent response",
    "agentTree": "Agent Tree",
    "agents": "Agents",
    "agentsUsed": "Agents used",
    "aiDescription": "AI Generated",
    "aiDescriptionModel": "AI model",
    "aiDescriptionPrompt": "Custom prompt",
    "allAgents": "All agents",
    "allowedDomains": "Allowed domains",
    "analysis": "Analysis",
    "anonymous": "Anonymous",
    "answer": "Answer",
    "apiKey": "API Key",
    "apiKeys": "API Keys",
    "appearance": "Appearance",
    "arrayOfObjects": "Array of objects",
    "assistantMessage": "Assistant response",
    "attempts": "Attempts",
    "attention": "Attention",
    "audience": "Audience",
    "authentication": "Authentication",
    "auto": "Auto",
    "autoDetected": "Automatically detected",
    "autoProvisioning": "Auto provisioning",
    "autoProvisioningDescription": "Users who authenticate through these identity providers or domains will be automatically added to your organization with the default role.",
    "autoRefreshError": "Error",
    "autoRefreshOff": "Paused",
    "autoRefreshOn": "Live",
    "autoRefreshWarning": "Warning",
    "availableCredit": "Available balance",
    "averageLine": "Average",
    "avgChatsPerUser": "Chats per user",
    "avgMessagesPerChat": "Messages per chat",
    "avgTime": "Avg. time",
    "banned": "Banned",
    "black": "Black",
    "blocked": "Blocked",
    "blockedDomains": "Blocked domains",
    "blockedReasons": "Blocked reasons",
    "body": "Body",
    "browserEngine": "Browser engine",
    "browsers": "Browsers",
    "budgetTokens": "Budget tokens",
    "cached": "cached",
    "calendarEvent": "Event",
    "changePassword": "Change Password",
    "channels": "Channels",
    "chat": "Chat",
    "chatCreatedAgo": "Created",
    "chatOrigin": "Chat origin",
    "chatStatistics": "Statistics",
    "chatUpdatedAgo": "Last message",
    "chatWidget": "Chat Widget",
    "chunks": "Chunks",
    "clear": "Clear",
    "codeEditor": "Code",
    "collapseContext": "Hide context",
    "comment": "Comment",
    "comparison": "Comparison",
    "completeName": "Full name",
    "configMcpServer": "Configure MCP server",
    "configure": "Configure",
    "confirm": "Confirm",
    "confirmPassword": "Confirm password",
    "confirmWithEmail": "Type your email to confirm",
    "confirmWithPassword": "Enter your password to confirm",
    "connectMcpServer": "Connect MCP server",
    "connectSubAgent": "Connect sub-agent",
    "connectedAccounts": "Connected accounts",
    "connectionChecking": "Connection checking...",
    "connectionConnected": "Connected",
    "connectionError": "Connection error",
    "connectionIdle": "Not verified",
    "connectionStatus": "Connection",
    "connectionTypes": "Connection type",
    "const": "Constant",
    "contactUs": "Contact us",
    "content": "Content",
    "contentPreview": "Content preview",
    "conversationLengthBuckets": "Conversation length",
    "conversationOutline": "Conversation outline",
    "conversations": "Conversations",
    "conversationsOverTime": "Conversations over time",
    "costInUSD": "Cost in USD",
    "country": "Country",
    "crawlMode": "Crawl Mode",
    "createdAt": "Created at",
    "createdBy": "Created by",
    "credit": "Cretit",
    "creditRemaining": "Remaining credit",
    "creditUpdatedAt": "Credit updated at",
    "credits": "Credits",
    "crmSync": "CRM Sync",
    "curlExample": "cURL Example",
    "currentAgent": "Current agent",
    "currentPassword": "Current password",
    "currentSession": "Current session",
    "customCss": "Custom CSS",
    "customRange": "Custom range",
    "dailyUsage": "Daily usage",
    "dark": "Dark",
    "darkModePreference": "Dark mode",
    "datetime": "Date / Time",
    "day": "Day",
    "dayRateLimit": "Day Rate Limit",
    "days": "{count} day | {count} days",
    "default": "Default",
    "defaultMappingHint": "If no mapping is configured, the default one for the provider will be used.",
    "defaultRole": "Default role",
    "deleted": "Deleted",
    "deprecated": "Deprecated",
    "description": "Description",
    "deselectAction": "Remove",
    "details": "Details",
    "device": "Device",
    "deviceContext": "Device context",
    "deviceType": "Device type",
    "diagram": "Diagram",
    "disabled": "Disabled",
    "disallowPromptTraining": "Prompt Training disallowed",
    "dismissableNotice": "Notice",
    "documentType": "Document type",
    "documents": "Documents",
    "domainFilter": "Domain filter",
    "downloadFile": "Download file",
    "downloading": "Downloading",
    "duration": "Duration",
    "editApiTool": "Edit API Tool",
    "editIntegration": "Edit integration",
    "editMcpServer": "Edit MCP server",
    "editSubAgent": "Edit sub-agent",
    "effectiveCredit": "Effective credit",
    "email": "Email",
    "emailClaim": "Email claim",
    "emailDomain": "Email domain",
    "emailVerified": "Email verified",
    "embed": "Embed",
    "embedCode": "Embed Code",
    "enabled": "Enabled",
    "enabledTools": "Enabled tools",
    "endDate": "End date",
    "engagement": "Engagement",
    "enum": "Enum values",
    "error": "Error",
    "estimatedCost": "Estimated end-of-month cost",
    "estimatedCredit": "Estimated credit",
    "estimatedMonthlyCost": "Month-end estimate",
    "excludeDomains": "Exclude domains",
    "expandContext": "Show more context",
    "expireIn": "Expires in",
    "expires": "Expires",
    "expiresAt": "Expiration",
    "exportMyData": "Export my data",
    "externalAuth": "External authentication",
    "externalAuthDescription": "Configure external authentication providers to allow authentication via JWT tokens issued by these providers. Users authenticated through these providers will be automatically added to your organization with the default role (auto provisioning).",
    "externalContext": "External context",
    "externalContextSchema": "External context schema",
    "externalId": "External ID (CRM)",
    "fallbackModels": "Fallback models",
    "feedback": "Feedback",
    "fieldMappingFallback": "Fallback value",
    "fieldMappingSource": "Source field",
    "fieldMappingTarget": "Target field {number}",
    "fieldMappingTransform": "Transform",
    "fieldMappingTransformExtractDomainCompany": "Extract company from email domain",
    "fieldMappingTransformJoinArray": "Join array",
    "fieldMappingTransformMapValues": "Map values",
    "fieldMappingTransformNone": "None",
    "fieldMappingTransformSplitFirstLast": "Split first/last",
    "fieldMappingValueMap": "Value map",
    "file": "File",
    "fileUpload": "File Upload",
    "fileUploadAllowedMimeTypes": "Allowed file types",
    "fileUploadEnabled": "Enable file upload",
    "fileUploadMaxFileSize": "Max file size (MB)",
    "fileUploadMaxFilesPerChat": "Max files per chat",
    "fileUploadMaxFilesPerMessage": "Max files per message",
    "filters": "Filters",
    "floatingButtonPosition": "Button position",
    "folderName": "Folder name",
    "followExternal": "Follow External Links",
    "footer": "Footer",
    "forceOcr": "Force OCR",
    "formMaxOptionsPerStep": "Max options per step",
    "formMaxSteps": "Maximum steps",
    "frequencyPenalty": "Frequency Penalty",
    "fullDuration": "Duration (ms)",
    "gallery": "Gallery ({count} images)",
    "general": "General",
    "generateSchemaFromJson": "Generate schema from JSON",
    "goalOutcome": "Goal outcome",
    "groupReasoningAgents": "Group",
    "header": "Header",
    "headers": "Headers",
    "healthCheckPath": "Health check",
    "hour": "Hour",
    "hourRateLimit": "Hour Rate Limit",
    "hsAccessToken": "Access Token",
    "hsAccessTokenHint": "Create a HubSpot Private App with the following scopes: crm.objects.contacts.read, crm.objects.contacts.write, crm.objects.owners.read.",
    "hsDefaultOwnerId": "Default Owner ID",
    "hsDefaultOwnerIdHint": "HubSpot user ID to assign contacts to. Leave empty to not assign an owner.",
    "hsStaticProperties": "Static Properties",
    "hsStaticPropertiesHint": "Fixed properties added to every contact.",
    "httpHeaderKey": "Key",
    "httpHeaderValue": "Value",
    "httpHeaders": "HTTP headers",
    "iframe": "Iframe",
    "iframeCode": "Iframe Code",
    "impersonated": "Impersonated",
    "importing": "Importing",
    "inRedis": "In Redis",
    "inStock": "In stock",
    "includeDomains": "Include domains",
    "includeThoughts": "View reasoning",
    "indexStatus": "Index status",
    "info": "Info",
    "initialMessage": "Initial message",
    "input": "Input",
    "inputSchema": "Input Schema",
    "insertEmail": "Insert email",
    "integration": "Integration",
    "integrationConfig": "Configuration",
    "integrationDisabled": "Disabled",
    "integrationEnabled": "Enabled",
    "integrationFieldMapping": "Field mapping",
    "integrationProvider": "Provider",
    "integrationSyncLogs": "Sync logs",
    "integrationSyncLogsDescription": "Synchronization occurs automatically when a new lead is created.",
    "integrations": "Integrations",
    "interface": "Interface",
    "ipAddress": "IP Address",
    "isAutoJoinEnabled": "Automatically merge existing users with the same email",
    "issuer": "Issuer",
    "itemsPerPage": "Items Per Page",
    "jsonSample": "JSON sample",
    "jwksUrl": "JWKS URL",
    "key": "Key",
    "language": "Language",
    "languages": "Languages",
    "last14Days": "Last 14 days",
    "last30Days": "Last 30 days",
    "last7Days": "Last 7 days",
    "last90Days": "Last 90 days",
    "lastActive": "Last active",
    "lastMonth": "Last month",
    "lastReconciledAt": "Last reconciled at",
    "lastRefillAt": "Last refill at",
    "lastSync": "Last sync",
    "leadId": "Lead ID",
    "left": "Left",
    "light": "Light",
    "limit": "Limit",
    "limitedStock": "Limited stock",
    "linkedAgents": "Linked agents",
    "llmIssues": "LLM issues",
    "loadDelay": "Load Delay (ms)",
    "loaderStrategy": "Loader Strategy",
    "loaderStrategyDynamicImport": "Dynamic Import",
    "loaderStrategyInlineModule": "Inline Module",
    "loaderStrategyScriptSrc": "Script Src",
    "locale": "Language",
    "location": "Location",
    "logo": "Logo",
    "logoUrl": "Logo URL",
    "mainColor": "Main color",
    "manageProfileDescription": "Edit your name, password, avatar and more",
    "maxDepth": "Max Depth",
    "maxMessageLength": "Max Message Length",
    "maxOutputTokens": "Max Tokens",
    "maxPages": "Max Pages",
    "maxResults": "Max results",
    "maxStepCount": "Max Steps",
    "maxUses": "Max uses",
    "mcpAuthType": "Authentication type",
    "mcpServer": "MCP Server",
    "mcpServerUrl": "MPC server URL",
    "mcpStatelessServer": "Stateless client",
    "message": "Message",
    "messageDetails": "Message detail",
    "messagePlaceholder": "Placeholder",
    "messages": "Messages",
    "metadata": "Metadata",
    "method": "Method",
    "mimeTypeDocuments": "Documents",
    "mimeTypeImages": "Images",
    "mimeTypeText": "Text",
    "minuteRateLimit": "Minute Rate Limit",
    "model": "Model",
    "modelParameters": "Model parameters",
    "month": "Month",
    "monthRateLimit": "Month Rate Limit",
    "monthlyCost": "Monthly cost",
    "multipleChoiceAllowCustomAnswer": "Allow custom answer",
    "multipleChoiceMaxOptions": "Maximum number of options",
    "name": "Name",
    "nameClaim": "Name claim",
    "never": "Never",
    "newChat": "New chat",
    "newPassword": "New password",
    "no": "No",
    "noDataAvailable": "No data available",
    "noDataRetention": "ZDR",
    "noFieldMapping": "No custom field mapping configured",
    "noIntegrations": "No integrations configured",
    "noPromptTraining": "No Prompt Training",
    "noSyncLogs": "No sync logs found",
    "noTimingData": "No data yet. Make a chat request to see timing logs.",
    "noTimingDataDesc": "Start a conversation with an agent to see timing logs here in real time.",
    "noTimingDataTitle": "No data available",
    "notAvailable": "Not available",
    "notConfigured": "Not configured",
    "notConnected": "Not connected",
    "notificationTitle": {
      "document_error": "Document processing failed",
      "organization": {
        "created": "Organization Created",
        "invite": "Organization Invite",
        "invite_accepted": "Invitation Accepted",
        "invite_rejected": "Invitation Rejected",
        "removed": "Removed from Organization"
      },
      "password_reset_requested": "A password reset has been requested"
    },
    "notificationType": {
      "api_key_expiring": "API Key expiring",
      "chat_blocked": "Chat blocked",
      "chat_warning": "Chat warning",
      "document_error": "Document error",
      "generic": "Generic",
      "organization": "Organization",
      "password_reset_requested": "Password reset requested"
    },
    "oauthAuthorizationUrl": "OAuth Authorization URL",
    "oauthClientId": "OAuth Client ID",
    "oauthClientSecret": "OAuth Client Secret",
    "oauthScopes": "OAuth Scopes",
    "oauthTokenUrl": "OAuth Token URL",
    "ocrUsed": "OCR",
    "older": "Older",
    "openSource": "Open source",
    "operatingSystems": "Operating systems",
    "or": "Or",
    "organization": "Organization",
    "organizations": "Organizations",
    "origin": "Origine",
    "originalMessage": "Original answer",
    "origins": "Origins",
    "outOfStock": "Out of stock",
    "output": "Output",
    "outputSchema": "Output Schema",
    "pages": "Pages",
    "passphrase": "Enter passphrase",
    "password": "Password",
    "peakHours": "Peak hours",
    "period": "Period",
    "phaseBreakdown": "Phase breakdown",
    "phone": "Phone number",
    "picture": "Picture",
    "postStreaming": "Post-streaming",
    "preStreaming": "Pre-streaming",
    "presencePenalty": "Presence Penalty",
    "preview": "Preview",
    "privacy": "Privacy",
    "privacyPolicyNotice": "Visible in the contact form.",
    "processedAt": "Processed at",
    "processing": "Processing...",
    "profile": "Profile",
    "prompt": "Prompt",
    "properties": "Properties",
    "provider": "Provider",
    "providerOrganizationId": "Provider ID",
    "providerTimeoutMs": "Provider timeout (ms)",
    "qrCode": "QR Code",
    "qdrantSync": "Vector Sync",
    "question": "Question",
    "rateLimits": "Rate Limits",
    "read": "Read",
    "reasoning": "Reasoning",
    "reasoningAgentTester": "Reasoning Agent Tester",
    "reasoningDetails": "Reasoning details",
    "reasoningEffort": "Reasoning effort",
    "reasoningSummary": "Reasoning summary",
    "referrerDomains": "Referrer domains",
    "refillAmount": "Refill amount",
    "rememberMe": "Remember me",
    "requestCount": "Requests",
    "requests": "Requests",
    "requestsPerAgent": "Requests per agent",
    "requestsUsed": "Requests used",
    "required": "Required",
    "requiredFields": "Required fields",
    "revisedMessage": "Revised answer",
    "right": "Right",
    "riskScoreBands": "Risk score bands",
    "role": "Role",
    "scheduledAt": "Scheduled at",
    "schemaRootArray": "Array",
    "schemaRootObject": "Object",
    "schemas": "Schemas",
    "screenCategories": "Screen resolution",
    "searchAndExecution": "Search & execution",
    "searchMode": "Search Mode",
    "searchRecencyFilter": "Recency filter",
    "sectionConversationQuality": "Conversation quality",
    "sectionCostTrend": "Monthly cost trend",
    "sectionDeviceContext": "Devices & context",
    "sectionTraffic": "Traffic",
    "security": "Security",
    "selectAgent": "Select an agent",
    "selectedHint": "Selected",
    "sentiment": "Sentiment",
    "sentimentTrends": "Sentiment trends",
    "serverInfo": "MCP Server info",
    "settings": "Settings",
    "sfApiVersion": "API Version",
    "sfClientId": "Client ID",
    "sfClientSecret": "Client Secret",
    "sfExternalIdField": "External ID Field",
    "sfInstanceUrl": "Instance URL",
    "shareWith": "Share with agents",
    "showExtendedSteps": "Extended steps view",
    "showing": "Showing",
    "similarity": "Similarity",
    "sitemapUrl": "Sitemap URL",
    "slowest": "Slowest",
    "slug": "Slug",
    "smoothStream": "Smooth streaming",
    "source": "Source",
    "sources": "Sources",
    "startDate": "Start date",
    "startUrl": "Start URL",
    "status": "Status",
    "smartRanking": "Smart Ranking",
    "freshnessBoost": "Freshness Boost",
    "freshnessScale": "Freshness Scale",
    "freshnessWeight": "Freshness Weight",
    "mmr": "Maximal Marginal Relevance (MMR)",
    "mmrDiversity": "MMR Diversity",
    "mmrCandidatesLimit": "Candidates Limit",
    "priority": "Priority",
    "documentPriority": "Document Priority",
    "hasRedundantChunks": "Has Redundant Chunks",
    "redundantChunks": "Redundant chunks",
    "priority_1": "Lowest",
    "priority_2": "Low",
    "priority_3": "Normal",
    "priority_4": "High",
    "priority_5": "Critical",
    "steps": "steps",
    "streaming": "Streaming",
    "style": "Style",
    "subAgent": "Sub-agent",
    "subject": "Subject",
    "syncStatus": "Sync status",
    "targetAll": "All users",
    "targetOrganization": "Organization",
    "targetType": "Target",
    "targetUser": "Specific user",
    "temperature": "Temperature",
    "testConnection": "Test connection",
    "testPlayground": "Test Playground",
    "textColor": "Text color",
    "theme": "Theme",
    "thinking": "Thinking",
    "thinkingBudget": "Thinking budget",
    "thinkingDisplay": "Thinking display",
    "thinkingEffort": "Thinking effort",
    "thinkingLevel": "Thinking level",
    "thinkingType": "Thinking type",
    "thisMonth": "This month",
    "timelineSteps": "Timeline steps",
    "timeoutMs": "Timeout (ms)",
    "timezoneRegions": "Timezone region",
    "title": "Title",
    "today": "Today",
    "tokens": "tokens",
    "tool": "Tool",
    "toolName": "Tool name: {name}",
    "tools": "Tools",
    "topPages": "Top pages",
    "topTopics": "Trending topics",
    "total": "Total",
    "totalConversations": "Chat in total",
    "totalCost": "Total cost",
    "totalItemsCount": "Items: {total}",
    "totalMessages": "Messages in total",
    "totalPages": "of {total}",
    "trustedOrigins": "Trusted Origins",
    "tuning": "Tuning",
    "type": "Type",
    "typeMain": "Main",
    "typeSub": "Sub",
    "uniqueUsers": "Unique users",
    "unitChat": "chats",
    "unitChatPerUser": "chats",
    "unitMessages": "messages",
    "unitMessagesPerChat": "messages",
    "unitUsers": "users",
    "unknown": "Unknown",
    "unread": "Unread",
    "updateProfile": "Update profile",
    "updatedAt": "Updated at",
    "upload": "Upload {index}/{total}",
    "url": "Web page URL",
    "usage": "Usage",
    "useBrowserEngine": "Browser engine",
    "useExtractionStrategy": "Use AI",
    "user": "User",
    "userInput": "Selected option",
    "userPrompt": "User question",
    "userQuestion": "Question",
    "userTones": "User tone",
    "users": "Users",
    "value": "Value",
    "version": "Version",
    "viewPdfPage": "View PDF page",
    "visibility": "Visibility",
    "visualEditor": "Visual",
    "vote": "Vote",
    "webSearch": "Web search",
    "webSearchEnabled": "Enable web search",
    "webSearchNative": "Built-in",
    "webSearchProvider": "Search provider",
    "week": "Week",
    "welcome": "Welcome to {appName}!",
    "white": "White",
    "widgetUrl": "Widget URL",
    "year": "Year",
    "yes": "Yes",
    "yesterday": "Yesterday",
    "zeroDataRetention": "Zero Data Retention (ZDR)"
  },
  "language": {
    "de": "German",
    "en": "English",
    "english": "English",
    "es": "Spanish",
    "fr": "French",
    "french": "French",
    "german": "German",
    "it": "Italian",
    "italian": "Italian",
    "spanish": "Spanish"
  },
  "lead": {
    "contactReason": {
      "appointment": "Appointment",
      "callback_request": "Callback request",
      "complaint": "Complaint",
      "info_request": "Information request",
      "other": "Other",
      "quote_request": "Quote request",
      "support": "Support"
    },
    "label": {
      "budget": "Budget",
      "company": "Company",
      "contactReason": "Contact reason",
      "conversationSummary": "Conversation summary",
      "preferredContactMethod": "Preferred contact method",
      "preferredContactTime": "Preferred contact time",
      "productInterest": "Product interest",
      "sentiment": "Sentiment",
      "topics": "Topics",
      "urgency": "Urgency"
    },
    "preferredContactMethod": {
      "any": "Any",
      "email": "Email",
      "phone": "Phone",
      "whatsapp": "WhatsApp"
    },
    "preferredContactTime": {
      "afternoon": "Afternoon",
      "any": "Any",
      "evening": "Evening",
      "morning": "Morning"
    },
    "sentiment": {
      "excited": "Excited",
      "frustrated": "Frustrated",
      "negative": "Negative",
      "neutral": "Neutral",
      "positive": "Positive"
    },
    "urgency": {
      "high": "High",
      "low": "Low",
      "medium": "Medium"
    }
  },
  "mcpAuthType": {
    "headers": "HTTP Headers (API Key)",
    "oauth": "OAuth 2.0 per user"
  },
  "mcpServerStatus": {
    "active": "Active",
    "error": "Error",
    "inactive": "Inactive"
  },
  "member": {
    "agentAccess": {
      "hint": "Leave empty to let this member use every organization agent. Select agents to limit them to those only.",
      "managerHint": "Owners and admins can use every agent; their access cannot be restricted."
    }
  },
  "message": {
    "copied": "Copied to clipboard",
    "unauthorized": "You do not have permission to manage channels.",
    "accountLinkEmailMismatch": "You can only link accounts that use the same email as your profile.",
    "accountLinkError": "Unable to link the account. Please try again.",
    "accountUnlinked": "Account disconnected",
    "agentAccessDenied": "You do not have access to this agent",
    "agentAccessDeniedAction": "View available agents",
    "agentActivated": "Agent activated successfully",
    "agentDeactivated": "Agent deactivated successfully",
    "agentNotFound": "Agent not found",
    "analyzeChatSuccess": "Conversation analyzed successfully",
    "banSuccess": "User banned successfully",
    "blockChatSuccess": "Conversation blocked successfully",
    "bulkUnlinkAllDeleteConfirm": "{count} document(s) will be permanently deleted because they have no other linked agents. Do you want to proceed?",
    "bulkUnlinkMixedConfirm": "{unlinkCount} document(s) will be unlinked and {deleteCount} will be permanently deleted (they have no other linked agents). Do you want to proceed?",
    "cancelInvitationConfirm": "Are you sure you want to cancel the invitation for {email}?",
    "cancelInvitationSuccess": "Invitation cancelled successfully",
    "chatErrorBadRequest": "An error occurred with the request. Start a new chat to continue.",
    "chatErrorContextWindow": "The conversation has become too long. Start a new chat to continue.",
    "chatErrorConversationBlocked": "This conversation has been blocked for policy violations.",
    "chatErrorCreditExhausted": "Service unavailable. Please try again later.",
    "chatErrorGatewayPromptTraining": "Model \"{model}\" does not support the \"Disable prompt training\" option. Disable this setting in the agent's gateway configuration or choose a compatible model.",
    "chatErrorGatewayZdr": "Model \"{model}\" does not support the \"Zero Data Retention\" option. Disable ZDR in the agent's gateway configuration or choose a compatible model.",
    "chatErrorGeneric": "An error occurred. Start a new chat if the problem persists. Retrying in {seconds}...",
    "chatErrorInternalServer": "A server error occurred. Start a new chat to continue.",
    "chatErrorNotFound": "The conversation is no longer available. Start a new chat to continue.",
    "chatErrorOriginNotAllowed": "The request origin is not allowed. Contact the system administrator.",
    "chatErrorRateLimit": "The rate limit has been exceeded. Retrying in {seconds} seconds...",
    "chatErrorRetrying": "Retrying in {seconds} seconds...",
    "checkYourEmail": "Check your email inbox",
    "clearTimingLogsConfirm": "Clear all timing logs?",
    "confirm": "Are you sure you want to proceed?",
    "confirmRefillCredits": "Are you sure you want to refill the credit of {amount} €?",
    "contentTruncated": "Content truncated. Total characters: {total}",
    "crawlError": "Error during crawling",
    "createFolderSuccess": "Folder created successfully",
    "defaultAgentWelcome": "Hello! How can I help you today?",
    "defaultPrivacyPolicyNotice": "By sending the request you accept our [Privacy Policy](https://www.iubenda.com/privacy-policy/46350192).",
    "deleteAllNotificationsConfirm": "Are you sure you want to delete all notifications?",
    "deleteBulkDocumentConfirm": "Are you sure you want to delete the selected documents? They will be removed from all linked agents.",
    "deleteDocumentConfirm": "Are you sure you want to delete this document? It will be removed from all linked agents.",
    "deleteDocumentConfirmWithAgents": "Are you sure you want to delete this document? It will be removed from the following agents:{agents}",
    "deleteFolderConfirm": "Are you sure you want to delete this folder? All documents inside will be removed from the agent.",
    "deleteFolderSuccess": "Folder deleted successfully",
    "deleteMyConversationsConfirm": "Are you sure you want to permanently delete all your conversations? This action cannot be undone.",
    "deleteNotificationConfirm": "Are you sure you want to delete this notification?",
    "deleteProfileBlockedSoleOwner": "You are the sole owner of {organizations}. Transfer ownership or delete the organizations before deleting your account.",
    "deleteProfileConfirm": "You are about to permanently delete your account: your profile will be anonymized and the content of your conversations erased. This action cannot be undone.",
    "deleteProfileDescription": "Anonymize your account and erase the content of your conversations (right to be forgotten).",
    "diagramRenderError": "Could not render diagram.",
    "empty": "No items found",
    "endpointActivated": "Endpoint activated successfully",
    "endpointDeactivated": "Endpoint deactivated successfully",
    "error": "Error",
    "exportError": "Error while exporting data",
    "exportFailed": "The data export failed. Please try again later.",
    "exportMyDataDescription": "Download a complete copy of your personal data as a ZIP archive (GDPR Art. 15 and 20).",
    "exportRequested": "We are preparing your archive: you will receive an email with the download link.",
    "exportSuccess": "CSV exported successfully",
    "feedbackSubmitError": "Submission failed. Please try again.",
    "feedbackSubmittedMessage": "Your feedback has been submitted successfully.",
    "feedbackSubmittedTitle": "Thank you!",
    "fileAlreadyImported": "Already imported",
    "fileAlreadyImportedExistingList": "The following files are already present in the organization:\n{names}",
    "fileAlreadyImportedLink": "This file has already been imported. Do you want to link the existing document to the current agent or create a new one?",
    "fileAlreadyImportedNewList": "The following files are new and will be imported normally:\n{names}",
    "fileAlreadyImportedQuestion": "Do you want to link the existing files to the current agent?",
    "fileAlreadyLinkedToAgent": "The following files are already linked to the current agent:\n{names}",
    "fileLimitPerChat": "You have reached the limit of {max} files for this conversation.",
    "fileLimitPerMessage": "You can attach at most {max} files per message.",
    "geolocationPermissionDenied": "Location access denied. Please allow it in your browser settings.",
    "geolocationUnavailable": "Location unavailable. Please try again or enter your location manually.",
    "getMcpServerInfoError": "An error occurred while loading the tools.",
    "importError": "Error during import",
    "importSuccess": "{count} documents imported successfully",
    "importing": "Importing...",
    "insufficientCredit": "Insufficient credit. Please try again later.",
    "insufficientCreditMessage": "Your credit is insufficient to complete this operation. Please contact the system administrator for more information.",
    "integrationCreated": "Integration created successfully",
    "integrationDeleted": "Integration deleted successfully",
    "integrationDisabled": "Integration disabled",
    "integrationEnabled": "Integration enabled",
    "integrationTestFailed": "Connection test failed: {error}",
    "integrationTestSuccess": "Connection verified successfully",
    "integrationUpdated": "Integration updated successfully",
    "invalidJson": "The input is not valid JSON",
    "invitationAccepted": "Invitation accepted",
    "invitationAlreadyHandled": "Invitation already handled",
    "invitationDeclined": "Invitation declined",
    "invitationToJoinOrganization": "You have been invited to join",
    "leadSubmitError": "Failed to submit. Please try again.",
    "leadSubmittedMessage": "Your information has been submitted successfully.",
    "leadSubmittedTitle": "Thank you!",
    "leftOrganization": "You have successfully left the organization",
    "loadConversationsError": "Failed to load conversations",
    "loading": "Loading...",
    "loadingError": "Error while loading",
    "mcpServerCheckError": "Error while checking MCP Server: {error}",
    "mcpServerCheckSuccess": "MCP Server check successful",
    "moveDocumentSuccess": "Document moved successfully",
    "noActiveSessions": "No other active sessions",
    "noChats": "No chat available",
    "noConnectedAccounts": "No connected accounts",
    "noConversations": "No conversations found",
    "noConversationsHint": "Start a new chat to see it appear here.",
    "noCreditsData": "No credit data available",
    "noEndpointLogs": "No endpoint logs available",
    "noLinkedAgents": "No linked agents",
    "noNotifications": "No notifications",
    "noOptions": "No options",
    "noResults": "No results",
    "oauthConfigIncomplete": "OAuth configuration incomplete. Set the Client ID in the MCP server settings.",
    "oauthConnected": "OAuth authorization completed successfully",
    "oauthError": "Error during OAuth authorization",
    "organizationNotSelected": "No organization selected",
    "pageNotFound": "Page not found",
    "passwordChangeSuccess": "Password changed successfully",
    "passwordResetSuccess": "Password reset successfully",
    "readError": "Error while reading",
    "reasoningAgent": "This is a reasoning agent. It is not designed to maintain the conversation history, each message is processed independently.",
    "recoverPasswordSuccess": "Recovery email sent successfully",
    "refillFailed": "Refill failed. Please try again later.",
    "refillSuccess": "Refill completed successfully",
    "refreshSuccess": "Refresh completed successfully",
    "removeSuccess": "Removal completed successfully",
    "renameFolderSuccess": "Folder renamed successfully",
    "selectedCount": "{count} of {total} selected",
    "sendInvitationConfirm": "Are you sure you want to resend the invitation to {email}?",
    "sessionRevoked": "Session signed out",
    "sharedSuccess": "Document shared successfully",
    "sitemapUrlRequired": "Sitemap URL is required",
    "startUrlRequired": "Start URL is required",
    "submitError": "Error while saving",
    "submitSuccess": "Save completed successfully",
    "success": "Success",
    "testExecutionError": "Error executing test",
    "toolNameAutoGenerated": "The tool name will be generated automatically",
    "typeToSearch": "Start typing to search...",
    "unbanSuccess": "User unbanned successfully",
    "unblockChatSuccess": "Conversation unblocked successfully",
    "unlinkAgentConfirm": "Are you sure you want to remove this agent from the document? The document will remain available for other linked agents.",
    "unlinkDocumentConfirm": "Are you sure you want to unlink this document from the agent? The document will remain available for other linked agents.",
    "unlinkLastAgentDeleteConfirm": "This is the last agent linked to this document. Removing it will permanently delete the document. Do you want to proceed?",
    "unlinkSuccess": "Document unlinked successfully",
    "urlAlreadyImported": "Already imported",
    "urlAlreadyImportedLink": "This URL has already been imported. Do you want to link it to the current agent?",
    "userUpdateSuccess": "User profile updated successfully",
    "warning": "Warning"
  },
  "messagePart": {
    "expandChunkContext": "Reading more context...",
    "geocode": "Looking up a location...",
    "getWeather": "Fetching weather data...",
    "readDocumentFile": "Reading the original document...",
    "reasoning": "Reasoning...",
    "requestGeolocation": "Requesting location...",
    "requestOAuthConnection": "Connecting...",
    "requestOAuthConnectionButton": "Connect {name}",
    "requestOAuthConnectionInfo": "Authorization requested to access {name}'s data.",
    "requestOAuthConnectionPrompt": "To access {name} data, you need to authorize the connection.",
    "requestOAuthConnectionSuccess": "Successfully connected to {name}.",
    "revisedAnswers": "Search frequently asked questions...",
    "runWorker": "Delegating to a worker...",
    "searchingDocuments": "Memory search...",
    "showArtifact": "Preparing content...",
    "showCalendarEvent": "Creating calendar event...",
    "showComparison": "Building comparison...",
    "showContactForm": "Creating contact form...",
    "showDiagram": "Rendering diagram...",
    "showEmail": "Composing email...",
    "showForm": "Creating form...",
    "showImageGallery": "Loading gallery...",
    "showLocation": "Loading location...",
    "showMessage": "Composing message...",
    "showMultipleChoice": "Show the options...",
    "showProducts": "Loading products...",
    "showQrCode": "Generating QR code...",
    "showSources": "Loading sources...",
    "showSuggestedReply": "Suggest a reply...",
    "showWeather": "Loading forecast...",
    "showWebPages": "Loading pages...",
    "stepCount": "{n} step | {n} steps",
    "stepDocument": "Document",
    "stepError": "Error",
    "stepExcerpts": "{n} excerpt | {n} excerpts",
    "stepInput": "Input",
    "stepNoResults": "No results found",
    "stepOutput": "Output",
    "steps": "Processing",
    "streaming": "Loading...",
    "tool": "Running a tool...",
    "webSearch": "Searching the web..."
  },
  "models": {
    "claude-fable-5": "Claude Fable 5",
    "claude-haiku-45": "Claude Haiku 4.5",
    "claude-opus-46": "Claude Opus 4.6",
    "claude-opus-47": "Claude Opus 4.7",
    "claude-opus-48": "Claude Opus 4.8",
    "claude-sonnet-46": "Claude Sonnet 4.6",
    "claude-sonnet-5": "Claude Sonnet 5",
    "glm-52": "GLM 5.2",
    "glm-52-fast": "GLM 5.2 Fast",
    "deepseek-v32": "Deepseek v3.2",
    "deepseek-v32-thinking": "Deepseek v3.2 Thinking",
    "deepseek-v4": "Deepseek v4.0",
    "deepseek-v4-flash": "Deepseek v4.0 Flash",
    "deepseek-v4-pro": "Deepseek v4.0 Pro",
    "gemini-25-flash": "Gemini 2.5 Flash",
    "gemini-25-flash-lite": "Gemini 2.5 Flash Lite",
    "gemini-25-pro": "Gemini 2.5 Pro",
    "gemini-3-flash": "Gemini 3 Flash",
    "gemini-3-pro-preview": "Gemini 3 Pro Preview",
    "gemini-31-flash-lite": "Gemini 3.1 Flash Lite",
    "gemini-31-flash-lite-preview": "Gemini 3.1 Flash Lite Preview",
    "gemini-31-pro-preview": "Gemini 3.1 Pro Preview",
    "gemini-35-flash": "Gemini 3.5 Flash",
    "gpt-5-mini": "ChatGPT 5 Mini",
    "gpt-5-nano": "ChatGPT 5 Nano",
    "gpt-51-instant": "ChatGPT 5.1 Instant",
    "gpt-51-thinking": "ChatGPT 5.1 Thinking",
    "gpt-52": "ChatGPT 5.2",
    "gpt-52-chat": "ChatGPT 5.2 Chat",
    "gpt-54": "ChatGPT 5.4",
    "gpt-54-mini": "ChatGPT 5.4 Mini",
    "gpt-54-nano": "ChatGPT 5.4 Nano",
    "gpt-54-pro": "ChatGPT 5.4 Pro",
    "gpt-55": "ChatGPT 5.5",
    "gpt-55-pro": "ChatGPT 5.5 Pro",
    "grok-43": "Grok 4.3",
    "qwen36-plus": "Qwen 3.6 Plus",
    "qwen37-max": "Qwen 3.7 Max",
    "qwen37-plus": "Qwen 3.7 Plus"
  },
  "placeholder": {
    "apiToolName": "e.g. get-product-availability",
    "apiToolUrl": "https://api.example.com/resource/{param}",
    "askAnything": "Type your message...",
    "autoDetect": "Auto detect",
    "comment": "Write your comment...",
    "completeName": "Enter full name",
    "constValue": "Constant value",
    "customAnswer": "Type your answer...",
    "description": "Enter description",
    "documentContent": "Enter document content",
    "documentName": "Enter document name",
    "documentUrl": "Enter the URL of the web page to import",
    "email": "Enter your email address",
    "endDate": "Select end date",
    "enterYourQuestion": "Enter your question...",
    "insert": "Type here...",
    "insertOrigin": "https://example.com",
    "limit": "Enter the limit",
    "loading": "Loading...",
    "mcpServerHealthCheckPath": "Enter the health check endpoint",
    "mcpServerUrl": "Enter the MCP Server URL",
    "model": "Select model",
    "name": "Enter name",
    "noTrustedOrigins": "No trusted origins configured",
    "oauthAuthorizationUrl": "e.g. https://provider.com/oauth/authorize",
    "oauthClientId": "e.g. my-client-app",
    "oauthClientSecret": "Enter the client secret",
    "oauthScopes": "e.g. read:contacts write:contacts",
    "oauthTokenUrl": "e.g. https://provider.com/oauth/token",
    "pages": "1, 4, 6, 8-12",
    "pasteJsonSample": "Paste a JSON example to generate the schema",
    "phone": "Enter your phone number",
    "prompt": "Enter the prompt",
    "request": "Request...",
    "search": "Search...",
    "secretEdit": "Leave blank to keep the current secret",
    "autoGenerated": "Auto-generated if left blank",
    "select": "Select",
    "selectAgent": "Select an agent",
    "selectLanguage": "Select language",
    "selectPriority": "Select priority",
    "similarity": "Enter the similarity",
    "sitemapUrl": "https://example.com/sitemap.xml",
    "slug": "Enter a URL-friendly slug",
    "startDate": "Select start date",
    "startUrl": "https://example.com",
    "temperature": "Enter the temperature",
    "title": "Enter title",
    "uploadFile": "Upload a file"
  },
  "problems": {
    "conflict": "A conflict occurred. The resource may already exist.",
    "conversation-blocked": "This conversation has been blocked.",
    "credit-exhausted": "Credits exhausted. Contact your administrator.",
    "entity-not-found": "Resource not found or disabled.",
    "file-upload-disabled": "File upload is not enabled for this agent.",
    "file-upload-validation": "Invalid file: check size, type, or number of files.",
    "hubspot-missing-scopes": "The HubSpot token is missing required permissions. Add the \"crm.objects.owners.read\" scope.",
    "input-validation": "Input validation failed. Check the data format.",
    "internal-server-error": "An unexpected error occurred. Please try again later.",
    "method-not-allowed": "HTTP method not allowed for this endpoint.",
    "not-found": "Page not found.",
    "oauth-authorization-required": "OAuth authorization required. Complete the authorization flow for this MCP server.",
    "oauth-config-incomplete": "OAuth configuration incomplete. Set the Client ID to enable OAuth.",
    "origin-not-allowed": "Request origin is not allowed.",
    "rate-limit-exceeded": "Too many requests. Please try again later.",
    "unauthorized": "Authentication required. Please log in.",
    "validation-error": "Validation error. Check the submitted data."
  },
  "role": {
    "admin": "Administrator",
    "member": "Member",
    "owner": "Owner",
    "user": "User"
  },
  "releaseNotes": {
    "heading": "What's new",
    "lead": "Latest features, improvements and fixes.",
    "installed": "You're on"
  },
  "route": {
    "channels": "Channels",
    "agentEndpoints": "API Endpoints",
    "agents": "Agents",
    "apiTools": "API Tools",
    "backoffice": "Backoffice",
    "catalog": "Catalog",
    "chatLogs": "Chat logs",
    "copatForYou": "Eight Wave for-U",
    "dashboard": "Dashboard",
    "documents": "Documents",
    "endpointLogs": "Endpoint logs",
    "feedbacks": "Feedbacks",
    "frontoffice": "Frontoffice",
    "home": "Home",
    "integrations": "Integrations",
    "invitations": "Invitations",
    "leads": "Contacts",
    "mcpServer": "MCP Server",
    "members": "Members",
    "notifications": "Notifications",
    "organizations": "Organizations",
    "playground": "Playground",
    "reasoningLogs": "Reasoning logs",
    "releaseNotes": "Release notes",
    "revisedAnswers": "Revised Answers",
    "subAgents": "Sub-agents",
    "system": "System",
    "timingDebug": "Timing Debug",
    "users": "Users",
    "video": "Video",
    "virtualAssistant": "Virtual assistant"
  },
  "showForm": {
    "completed": "Form completed",
    "otherPlaceholder": "Other...",
    "step": "Step {current} of {total}"
  },
  "subAgentStatus": {
    "active": "Active",
    "inactive": "Inactive"
  },
  "time": {
    "future": "in",
    "past": "ago",
    "unit": {
      "day": "day | days",
      "hour": "hour | hours",
      "minute": "minute | minutes",
      "second": "second | seconds"
    }
  },
  "toolGroup": {
    "communication": "Communication",
    "delegation": "Delegation & automation",
    "knowledgeSearch": "Knowledge base & search",
    "locationWeather": "Location & weather",
    "personalization": "Personalization",
    "richContent": "Interactive content"
  },
  "toolGroupInfo": {
    "communication": "Emails, messages, contact forms, and calendar events.",
    "delegation": "Generic workers the agent can run in parallel to handle independent sub-tasks.",
    "knowledgeSearch": "Knowledge base search, document sources, and web page suggestions.",
    "locationWeather": "Geolocation, geocoding, interactive maps, and weather forecasts.",
    "personalization": "Per-user memory and the user's own uploaded files.",
    "richContent": "Structured content: artifacts, comparisons, image galleries, QR codes, and guided replies."
  },
  "tooltip": {
    "agentsUsedInfo": "Number of agents used compared to the maximum available.",
    "requestsUsedInfo": "Number of requests used compared to the maximum allowed."
  },
  "userFiles": {
    "title": "My files",
    "subtitle": "Files you uploaded in chat, available to the assistant.",
    "open": "Open file",
    "openInChat": "Open in chat",
    "exclude": "Remove file",
    "excludeTitle": "Remove file",
    "excludeConfirm": "Remove this file from your files? The assistant will no longer be able to search it. It stays available in the chat where you uploaded it.",
    "untitled": "Untitled file",
    "loading": "Loading…",
    "emptyTitle": "No files yet",
    "emptyHint": "Files you upload in chat are added here automatically and become searchable by the assistant.",
    "chatFilesTitle": "Files in this chat",
    "chatFilesEmpty": "No files uploaded in this chat.",
    "uploadedAt": "Uploaded",
    "allAgents": "All agents"
  },
  "validation": {
    "invalidPhoneNumber": "The number entered is incorrect",
    "invalidToolName": "Name must be snake_case or kebab-case (lowercase letters, numbers, underscores, and hyphens)",
    "passwordMismatch": "Passwords do not match"
  },
  "weather": {
    "airQuality": "Air quality",
    "aqiFair": "Fair",
    "aqiGood": "Good",
    "aqiHazardous": "Hazardous",
    "aqiModerate": "Moderate",
    "aqiPoor": "Poor",
    "aqiVeryPoor": "Very poor",
    "dailyForecast": "Daily forecast",
    "feelsLike": "Feels like",
    "today": "Today"
  }
}
